/**
 * What a surface's draw adds to its depth program, which three's own depth material lacks. A draw
 * records each injection on the material's userData, and every reader of a draw's depth asks here.
 */
import { composeInjections } from '../materialProgramInputs';
const DEPTH_INJECTIONS_KEY = 'godotDepthInjections';
const NONE = Object.freeze({});
/** The depth injections `userData`'s draw recorded, none for a surface that recorded none. */
export function drawDepthInjections(userData) {
    return userData[DEPTH_INJECTIONS_KEY] ?? NONE;
}
/** Whether `userData`'s draw adds anything to its depth program. */
export function addsDepthInjections(userData) {
    return drawDepthInjections(userData) !== NONE;
}
/** `userData` with `injection` after the injections already on `slot`, in a new object. */
export function withDepthInjection(userData, slot, injection) {
    const recorded = drawDepthInjections(userData);
    return {
        ...userData,
        [DEPTH_INJECTIONS_KEY]: { ...recorded, [slot]: composeInjections([recorded[slot], injection]) },
    };
}
//# sourceMappingURL=depthInjections.js.map